// extracted by mini-css-extract-plugin
export var skills = "style-module--skills--58d06";
export var skills2 = "style-module--skills-2--aceb3";
export var skills__btn = "style-module--skills__btn--ab9d7";
export var skills__row = "style-module--skills__row--4d430";
export var skills__text = "style-module--skills__text--3214d";
export var skills__textBlock = "style-module--skills__text-block--d51f3";
export var skills__title = "style-module--skills__title--463f9";
export var skills__wrap = "style-module--skills__wrap--f651d";